// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27 fill=%27none%27><path d=%27M3 4.5L6 7.5L9 4.5%27 stroke=%27%23808080%27 stroke-width=%271.25%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── InputRow ─────────────────────────────────────────────── */
.input-row {
  display: grid;
  grid-template-columns: 130px 1fr;
  gap: 14px;
  padding: 11px 0;
  align-items: baseline;
}

.input-row .lbl {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--text-muted);
}

.input-row.cols-2 {
  grid-template-columns: 130px 1fr 80px 1fr;
}

/* La ayuda y los errores van bajo su campo, en la columna del control, y no
   en la columna de la etiqueta (el grid los ponía ahí por ser un hijo más). */
.input-row > .helper-text {
  grid-column: 2 / -1;
  margin-top: -8px;
}

/* When the row carries an error, propagate the visual state to the helper
   slot for free (the control already gets \`.error\` via prop wiring). */
.input-row.error .helper-text {
  color: var(--danger);
}

/* ─── Input ────────────────────────────────────────────────── */
.form-input {
  border: 1px solid var(--border);
  background: var(--bg-alt);
  padding: 7px 10px;
  border-radius: var(--radius-1);
  font-size: var(--fs-ui);
  color: var(--text);
  font-family: var(--sans);
  width: 100%;
  box-sizing: border-box;
  outline: none;
  transition:
    border-color 120ms ease,
    box-shadow 120ms ease;
}

.form-input::placeholder {
  color: var(--text-muted);
}

/*
 * Focused state — native \`:focus-visible\` plus a Storybook-only \`.focused\`
 * escape hatch for visual-regression snapshots. The two share a single
 * declaration via \`:is(...)\` so the visual contract cannot drift. DO NOT
 * use the \`.focused\` class in production code; rely on \`:focus-visible\`.
 */
.form-input:is(:focus-visible, .focused) {
  border-color: var(--signal);
  box-shadow: var(--focus-ring);
}

.form-input.mono {
  font-family: var(--mono);
  font-size: var(--fs-2xs);
}

.form-input.tall {
  min-height: 78px;
  resize: vertical;
  padding: 9px 10px;
}

/* Error state — toggled by the \`error\` prop on Input/Select, or by
   InputRow when its \`error\` prop is truthy. */
.form-input.error,
.form-input[aria-invalid='true'] {
  border-color: var(--danger);
  box-shadow: var(--focus-ring-err);
}

.form-input:disabled,
.form-input.disabled {
  color: var(--text-muted);
  cursor: not-allowed;
  opacity: 0.7;
}

/* ─── Select ───────────────────────────────────────────────── */
/* Native <select> with a chevron adornment for parity with Input. */
.form-input.form-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right: 28px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 12px 12px;
}

/* ─── HelperText ────────────────────────────────────────────── */
.helper-text {
  margin-top: 6px;
  margin-bottom: 0;
  font-size: var(--fs-xs);
  color: var(--text-muted);
  line-height: 1.45;
}

.helper-text.err {
  color: var(--danger);
}

/* ─── FieldGrid ─────────────────────────────────────────────── */
.field-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px 32px;
  background: var(--bg-alt);
  border: 1px solid var(--border);
  border-radius: var(--r-data);
  padding: 22px 24px;
}

.field-grid.cols-3 {
  grid-template-columns: repeat(3, 1fr);
}

.field-display .field-label {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--text-muted);
  margin-bottom: 4px;
}

.field-display .field-value {
  font-size: var(--fs-note);
  color: var(--text);
}

.field-display .field-value.mono {
  font-family: var(--mono);
  font-size: var(--fs-ui);
}

.field-display .field-value.muted {
  color: var(--text-secondary);
}

/* ─── Totals ────────────────────────────────────────────────── */
.totals {
  margin-top: 20px;
  background: var(--bg-alt);
  padding: 16px 18px;
  border: 1px solid var(--border);
  border-radius: var(--r-data);
}

.totals .totals-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  font-size: var(--fs-ui);
}

.totals .totals-row .lbl {
  color: var(--text-secondary);
}

.totals .totals-row .v {
  font-family: var(--mono);
  font-variant-numeric: tabular-nums;
  color: var(--text);
}

.totals .totals-row.grand {
  border-top: 1px solid var(--border);
  margin-top: 6px;
  padding-top: 12px;
}

.totals .totals-row.grand .lbl {
  font-family: var(--display);
  font-size: var(--fs-md);
  color: var(--text);
}

.totals .totals-row.grand .v {
  font-size: var(--fs-prose);
  font-family: var(--display);
  font-weight: 400;
  color: var(--text);
}
`, "",{"version":3,"sources":["webpack://./src/ui/Form/Form.css"],"names":[],"mappings":"AAAA,iEAAiE;AACjE;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;8EAC8E;AAC9E;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;uEACuE;AACvE;EACE,oBAAoB;AACtB;;AAEA,iEAAiE;AACjE;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,iBAAiB;EACjB,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb;;yBAEuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;;EAKE;AACF;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;8CAC8C;AAC9C;;EAEE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;;EAEE,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;AACd;;AAEA,iEAAiE;AACjE,oEAAoE;AACpE;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,yDAA0Q;EAC1Q,4BAA4B;EAC5B,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA,kEAAkE;AAClE;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,kEAAkE;AAClE;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["/* ─── InputRow ─────────────────────────────────────────────── */\n.input-row {\n  display: grid;\n  grid-template-columns: 130px 1fr;\n  gap: 14px;\n  padding: 11px 0;\n  align-items: baseline;\n}\n\n.input-row .lbl {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--text-muted);\n}\n\n.input-row.cols-2 {\n  grid-template-columns: 130px 1fr 80px 1fr;\n}\n\n/* La ayuda y los errores van bajo su campo, en la columna del control, y no\n   en la columna de la etiqueta (el grid los ponía ahí por ser un hijo más). */\n.input-row > .helper-text {\n  grid-column: 2 / -1;\n  margin-top: -8px;\n}\n\n/* When the row carries an error, propagate the visual state to the helper\n   slot for free (the control already gets `.error` via prop wiring). */\n.input-row.error .helper-text {\n  color: var(--danger);\n}\n\n/* ─── Input ────────────────────────────────────────────────── */\n.form-input {\n  border: 1px solid var(--border);\n  background: var(--bg-alt);\n  padding: 7px 10px;\n  border-radius: var(--radius-1);\n  font-size: var(--fs-ui);\n  color: var(--text);\n  font-family: var(--sans);\n  width: 100%;\n  box-sizing: border-box;\n  outline: none;\n  transition:\n    border-color 120ms ease,\n    box-shadow 120ms ease;\n}\n\n.form-input::placeholder {\n  color: var(--text-muted);\n}\n\n/*\n * Focused state — native `:focus-visible` plus a Storybook-only `.focused`\n * escape hatch for visual-regression snapshots. The two share a single\n * declaration via `:is(...)` so the visual contract cannot drift. DO NOT\n * use the `.focused` class in production code; rely on `:focus-visible`.\n */\n.form-input:is(:focus-visible, .focused) {\n  border-color: var(--signal);\n  box-shadow: var(--focus-ring);\n}\n\n.form-input.mono {\n  font-family: var(--mono);\n  font-size: var(--fs-2xs);\n}\n\n.form-input.tall {\n  min-height: 78px;\n  resize: vertical;\n  padding: 9px 10px;\n}\n\n/* Error state — toggled by the `error` prop on Input/Select, or by\n   InputRow when its `error` prop is truthy. */\n.form-input.error,\n.form-input[aria-invalid='true'] {\n  border-color: var(--danger);\n  box-shadow: var(--focus-ring-err);\n}\n\n.form-input:disabled,\n.form-input.disabled {\n  color: var(--text-muted);\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n/* ─── Select ───────────────────────────────────────────────── */\n/* Native <select> with a chevron adornment for parity with Input. */\n.form-input.form-select {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  padding-right: 28px;\n  background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'><path d='M3 4.5L6 7.5L9 4.5' stroke='%23808080' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/></svg>\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-size: 12px 12px;\n}\n\n/* ─── HelperText ────────────────────────────────────────────── */\n.helper-text {\n  margin-top: 6px;\n  margin-bottom: 0;\n  font-size: var(--fs-xs);\n  color: var(--text-muted);\n  line-height: 1.45;\n}\n\n.helper-text.err {\n  color: var(--danger);\n}\n\n/* ─── FieldGrid ─────────────────────────────────────────────── */\n.field-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 18px 32px;\n  background: var(--bg-alt);\n  border: 1px solid var(--border);\n  border-radius: var(--r-data);\n  padding: 22px 24px;\n}\n\n.field-grid.cols-3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.field-display .field-label {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: var(--text-muted);\n  margin-bottom: 4px;\n}\n\n.field-display .field-value {\n  font-size: var(--fs-note);\n  color: var(--text);\n}\n\n.field-display .field-value.mono {\n  font-family: var(--mono);\n  font-size: var(--fs-ui);\n}\n\n.field-display .field-value.muted {\n  color: var(--text-secondary);\n}\n\n/* ─── Totals ────────────────────────────────────────────────── */\n.totals {\n  margin-top: 20px;\n  background: var(--bg-alt);\n  padding: 16px 18px;\n  border: 1px solid var(--border);\n  border-radius: var(--r-data);\n}\n\n.totals .totals-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 6px 0;\n  font-size: var(--fs-ui);\n}\n\n.totals .totals-row .lbl {\n  color: var(--text-secondary);\n}\n\n.totals .totals-row .v {\n  font-family: var(--mono);\n  font-variant-numeric: tabular-nums;\n  color: var(--text);\n}\n\n.totals .totals-row.grand {\n  border-top: 1px solid var(--border);\n  margin-top: 6px;\n  padding-top: 12px;\n}\n\n.totals .totals-row.grand .lbl {\n  font-family: var(--display);\n  font-size: var(--fs-md);\n  color: var(--text);\n}\n\n.totals .totals-row.grand .v {\n  font-size: var(--fs-prose);\n  font-family: var(--display);\n  font-weight: 400;\n  color: var(--text);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
